import { GetStaticProps } from "next";
import Image from "next/image";
import Contact from "../components/Contact";
import Layout from "../components/Layout";
import DrBirselUckun from "../public/dr_birsel_uckun.jpg";
import Clinic1 from "../public/clinic1.jpg";
import Clinic2 from "../public/clinic2.jpg";
import Clinic3 from "../public/clinic3.jpg";
import Clinic4 from "../public/clinic4.jpg";

const About = () => {
  return (
    <Layout>
      <div className="container mx-auto mt-10">
        <div className="flex flex-wrap">
          <div className="flex flex-row items-center justify-center flex-grow p-3 xl:justify-start xl:w-1/2">
            <Image
              src={DrBirselUckun}
              alt="Dr Birsel Uçkun"
              placeholder="blur"
              width={600}
              height={600}
              className="object-cover rounded-lg shadow-lg"
            />
          </div>
          <div className="flex items-center w-full px-4 mb-12 xl:w-1/2 lg:mb-0">
            <div className="w-full">
              <h1 className="my-10 text-4xl font-bold lg:text-5xl">
                Dr. I. Birsel Uçkun
              </h1>
              <div className="mx-auto lg:mx-0">
                <p className="mb-6 leading-loose">
                  Dr. Birsel Uçkun was born in Gaziantep in 1962. 1979-1982
                  Hacettepe, 1982-1985 she completed her education at Çukurova
                  University Faculty of Medicine. After completing her
                  compulsory service at Samsun Gynecology and Pediatric Hospital
                  between 1985-87, she started to work as a private practice
                  doctor in Çanakkale in 1987. She received Acupuncture training
                  in Acupuncture Training Center in Beijing University of China
                  in 1998. She has trainings on complementary medicine in
                  France, Russia and the USA. Bioresonance applications, which
                  started with Acmos frequency treatments in 2005, have been
                  continuing with Rayonex according to German technology Paul
                  Schmidt since 2012.
                </p>
                <div>
                  <a
                    className="inline-block w-full px-6 py-2 mb-3 font-semibold leading-loose text-white transition duration-200 bg-green-600 lg:mb-0 lg:mr-3 lg:w-auto hover:bg-sky-700 rounded-l-xl rounded-t-xl"
                    href="#contact"
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="relative bg-gray-50">
        <div className="relative z-10 pt-12 pb-20 lg:pt-20">
          <div className="container px-4 mx-auto">
            <div className="flex flex-wrap -mx-4">
              <div className="w-full p-3 lg:w-1/2">
                <h2 className="mt-4 mb-2 text-2xl font-bold lg:text-3xl font-heading">
                  Education
                </h2>
                <ul className="space-y-3">
                  <li>Çukurova University Faculty of Medicine, Turkey, 1985</li>
                  <li>
                    Acapuncture training at International Acupuncture Training
                    Center, China, 1998
                  </li>
                  <li>
                    Auriculotherapy Certification Institute and Laser
                    Acupuncture at Institut Francais de’Esthetque Medicale
                    (IFEM), France, 1998
                  </li>
                  <li>
                    Mesotherapy training at Societe Francaise de Mesotherapie,
                    2000
                  </li>
                  <li>
                    Medical hypnosis training at Yeditepe University, Turkey,
                    2003
                  </li>
                  <li>
                    Bioresonance training at Paris International Academy of
                    Bioenergetics in ACMOS, France, 2007
                  </li>
                  <li>
                    Bioresonance training at Moscow International V.M Bekhterev
                    Society of Energy, Russia, 2007
                  </li>
                </ul>
                <h2 className="mt-4 mb-2 text-2xl font-bold lg:text-3xl font-heading">
                  Congress Attended
                </h2>
                <ul className="space-y-3">
                  <li>
                    ICCAAAM Las Vegas International Acupuncture Congress, USA,
                    1999
                  </li>
                  <li>
                    Lyon-France International Acupuncture Congress, France, 2000
                  </li>
                  <li>
                    Istanbul International Acupuncture Congress, Turkey, 2002
                    and 2004
                  </li>
                  <li>
                    Antalya International Acupuncture Congress, Turkey, 2006
                  </li>
                  <li>Ankara Complementary Medicine Symposium, Turkey, 2009</li>
                </ul>
              </div>
              <div className="flex flex-col items-center justify-center flex-grow px-4 lg:w-1/2 md:mt-8">
                <div className="flex flex-wrap items-center justify-center flex-grow">
                  <div className="hidden 2xl:flex justfiy-center">
                    <Image
                      className="object-cover rounded-lg shadow-lg"
                      src={Clinic1}
                      width={237}
                      height={256}
                      alt="Dr. Birsel Uçkun Bioresonance Clinic"
                    />
                  </div>
                  <div className="flex 2xl:pl-3 justfiy-center">
                    <Image
                      className="object-cover rounded-lg shadow-lg"
                      src={Clinic2}
                      width={474}
                      height={256}
                      alt="Dr. Birsel Uçkun Bioresonance Clinic"
                    />
                  </div>
                </div>
                <div className="flex flex-wrap mt-10">
                  <div className="flex justfiy-center">
                    <Image
                      className="object-cover rounded-lg shadow-lg"
                      src={Clinic3}
                      width={474}
                      height={256}
                      alt="Dr. Birsel Uçkun Bioresonance Clinic"
                    />
                  </div>
                  <div className="hidden 2xl:flex 2xl:pl-3 justfiy-center">
                    <Image
                      className="object-cover rounded-lg shadow-lg"
                      src={Clinic4}
                      width={237}
                      height={256}
                      alt="Dr. Birsel Uçkun Bioresonance Clinic"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Contact />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      messages: (await import(`../messages/${locale}.json`)).default,
    },
  };
};

export default About;
